import GoogleIcon from '@mui/icons-material/Google';
import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { useAppDispatch } from '../store/hooks';
import { googleSignIn } from '../store/thunks/authThunks';
import { ReactComponent as HomeSvg } from '../svg/home.svg';
import Item from './common/Item';

const UnautheticatedHomePage = () => {
  const dispatch = useAppDispatch();

  /*
    Handle Google Signup with Firebase Auth
  */
  const handleGoogleSignup = () => {
    dispatch(googleSignIn(undefined));
  };

  return (
    <Stack direction="column" alignItems="center" spacing={0}>
      <HomeSvg width="150px" height="150px" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'center',
          maxWidth: '400px',
        }}>
        <Item>
          <Typography variant="h2" gutterBottom>
            Die beste Zeiterfassung App für Erzieher:innen
          </Typography>
        </Item>
        <Item>
          <Button
            variant="contained"
            fullWidth
            startIcon={<GoogleIcon sx={{ color: 'text.primary' }} />}
            onClick={handleGoogleSignup}
            color="secondary">
            <Typography variant="button" display="block" color="text.primary">
              Melde dich mit Google an
            </Typography>
          </Button>
        </Item>
        <Item>
          <Typography variant="body1" gutterBottom>
            Mit der Registrierung bei KITZE stimmst du den <Link href="/legal/terms">Nutzungsbedingungen</Link> zu. Schau dir unsere{' '}
            <Link href="/legal/policy">Datenschutz-Bestimmungen</Link> an.
          </Typography>
        </Item>
      </Box>
    </Stack>
  );
};

export default UnautheticatedHomePage;
